import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InstrumentType } from '@zero/shared/util-models';
import { FormCache, MinimumQuantitySurcharge } from '@zero/trade/domain';

@Component({
  selector: 'trade-confirm-hint',
  templateUrl: './trade-confirm-hint.component.html',
  imports: [TranslocoPipe],
})
export class TradeConfirmHintComponent {
  @Input() public cache?: FormCache;
  @Input() public minimumQuantitySurcharge?: MinimumQuantitySurcharge;

  public readonly InstrumentType = InstrumentType;
}
